import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#8347F2" tint={0.1}>
    {/* A table: a header row and a key column. */}
    <rect x="3" y="4" width="18" height="16" rx="2.5" />
    <path d="M3 9h18M9 9v11" />
  </ContentTile>
);
